var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoachInvitedStatus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8159_7126",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8159_7126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 6L12 11L20 6H4ZM4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V11C22 11.2833 21.9042 11.5208 21.7125 11.7125C21.5208 11.9042 21.2833 12 21 12C20.7167 12 20.4792 11.9042 20.2875 11.7125C20.0958 11.5208 20 11.2833 20 11V8L12.525 12.675C12.475 12.7083 12.3 12.7583 12 12.825C11.9167 12.825 11.8292 12.8125 11.7375 12.7875C11.6458 12.7625 11.5583 12.725 11.475 12.675L4 8V18H9.5C9.78333 18 10.0208 18.0958 10.2125 18.2875C10.4042 18.4792 10.5 18.7167 10.5 19C10.5 19.2833 10.4042 19.5208 10.2125 19.7125C10.0208 19.9042 9.78333 20 9.5 20H4ZM15.95 19.2L20.9 14.25C21.0833 14.0667 21.3167 13.975 21.6 13.975C21.8833 13.975 22.1167 14.0667 22.3 14.25C22.4833 14.4333 22.575 14.6667 22.575 14.95C22.575 15.2333 22.4833 15.4667 22.3 15.65L16.65 21.3C16.45 21.5 16.2167 21.6 15.95 21.6C15.6833 21.6 15.45 21.5 15.25 21.3L12.4 18.45C12.2167 18.2667 12.125 18.0333 12.125 17.75C12.125 17.4667 12.2167 17.2333 12.4 17.05C12.5833 16.8667 12.8167 16.775 13.1 16.775C13.3833 16.775 13.6167 16.8667 13.8 17.05L15.95 19.2Z",
    fill: "#BD9FF3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoachInvitedStatus);
export default __webpack_public_path__ + "static/media/coachInvitedStatus.d50d90364c90fdc6ec995cfa17e2e93a.svg";
export { ForwardRef as ReactComponent };